<template>
  <div>
    <!--    @touchmove.prevent @mousewheel.prevent-->
    <div class="main-pic">
      <img src="@/assets/image/mobile/mb-contact.jpg">
    </div>

    <div class="ct-map" v-if="showMap">
      <div class="close-map-btn el-icon-close" @click="showMap=false">
      </div>
      <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
        <!--缩放-->
        <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        <!--定位 :showAddressBar="true"-->
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :autoLocation="true"></bm-geolocation>
        <!--点-->
        <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP"></bm-marker>
      </baidu-map>
    </div>
    <div class="form-container">
      <div class="nav-icon" @click="showMap=!showMap">
        <img src="../../assets/image/mobile/nav-icon.png"/>导航
      </div>
      <div class="sv-header">
        <div class="sv-title">您可以通过以下表单和我们联系</div>
        <div class="sv-title-en">FILL IN INFORMATION</div>
        <div class="l--l"></div>
      </div>
      <div class="form-box">
        <el-form :model="form" ref="form" :show-message="false">
          <el-form-item style="margin-bottom: 8px"
                        prop="name"
                        :rules="[{required:true}]">
            <el-input v-model="form.name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px"
                        prop="phone"
                        :rules="[{required:true,pattern:/^1[34578]\d{9}$/,
                        trigger: ['blur', 'change']}]">
            <el-input v-model.number="form.phone" placeholder="电话"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px">
            <el-input v-model="form.wechat" placeholder="微信"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px"
                        prop="mail"
                        :rules="[{ required:true}]">
            <el-input v-model="form.mail" placeholder="邮箱"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 8px"
                        prop="mark"
                        :rules="[{required:true}]">
            <el-input type="textarea" v-model="form.mark" placeholder="留言信息"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="submit-btn" @click="onSubmit(form)">提交信息</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <mbFooter></mbFooter>
  </div>
</template>

<script>
  import mbFooter from "../../components/mobile/mbFooter";

  export default {
    components: {mbFooter},
    name: "mobile",
    data() {
      return {
        form: {
          name: '',
          phone: '',
          wechat: '',
          mail: '',
          mark: ''
        },
        map: {
          center: {lng: 1, lat: 1},
          zoom: 15,
          show: true,
          dragging: true
        },
        showMap: false,
        showAlert: false
      }
    },
    created() {
      this.$http.get('/api/company/info/list').then((res) => {
        this.companyInfo = res.data.rows[0]
        console.log('1',this.companyInfo)
        this.map.center={lng: this.companyInfo.longitude, lat: this.companyInfo.latitude}
      })
    },
    mounted() {
      this.form = {
        name: '',
        phone: '',
        wechat: '',
        mail: '',
        mark: ''
      }
    },
    methods: {
      handler({ map}) {
        map.enableScrollWheelZoom(true);
      },
      onSubmit(form) {
        //提交表单
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http.post('/api/leaveWord/info', this.form).then((res) => {
              console.log(res)
              if (res.data.code === 200) {
                this.$message('提交成功')
                // this.open()
                console.log(res.data.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
</script>

<style scoped>
  .main-pic {
    width: 100vw;
    margin: 0 0 6.2vw;
  }

  .main-pic img {
    width: 100%;
  }


  .wc-code img {
    width: 100%;
    height: 100%;
  }


  .ct-logo img {
    width: 100%;
  }

  .form-container {
    min-height: 60vh;
    position: relative;
  }

  .form-box {
    padding: 0 10vw;
  }

  .show-alert {
    font-size: .625em;
    color: #c62d2d;
  }

  .sv-title {
    font-weight: bold;
    text-align: center;
    margin: 6.4vw 0 2.4vw;
  }

  .sv-title-en {
    color: #888;
    font-size: 0.62em;
    text-align: center;
  }

  .l--l {
    width: 4vw;
    border: 0.4vw solid #6676e7;
    border-radius: 2em;
    margin: 2.4vw auto 4.8vw;
  }

  .submit-btn {
    width: 22.4vw;
    height: 8vw;
    background-color: #6676e7;
    color: #fff;
    font-size: 0.75em;
    line-height: 8vw;
    text-align: center;
    margin: 9px auto 0;
    border-radius: 2em;
  }

  .nav-icon {
    width: 8vw;
    /*height: 8vw;*/
    position: absolute;
    right: 2vw;
    bottom: 4vw;
    font-size: .625em;
    text-align: center;
    color: #3867e0;
  }

  .nav-icon img {
    width: 100%;
  }

  .ct-map {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 6;
  }

  .map {
    width: 100%;
    height: 100%;
  }

  .close-map-btn {
    width: 10vw;
    height: 10vw;
    background-color: #fff;
    line-height: 10vw;
    font-weight: bold;
    border-radius: 10px;
    font-size: 1.25em;
    position: absolute;
    top: 5vw;
    right: 5vw;
    z-index: 2;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/contact/mobile.vue